module.exports = __webpack_public_path__ + "img/25-skott-vertical.8e49ef6a.jpg";